module.exports = __webpack_public_path__ + "img/CADRE-logo_dark.209f92f2.svg";